/*
 * Copyright 2010-2024 JetBrains s.r.o. and Kotlin Programming Language contributors.
 * Use of this source code is governed by the Apache 2.0 license that can be found in the LICENSE file.
 */

import {KarmaWebpackOutputFramework} from "./src/KarmaWebpackOutputFramework";

module.exports = {
    'framework:webpack-output': ['factory', KarmaWebpackOutputFramework],
};